import React, { useEffect, useState } from "react";
import authApiService from "../services/authServices";
import CourtsDem from "../components/Courts/CourtsDem";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Modal from "../utils/modalUtils";
import { ThreeDots } from 'react-loader-spinner'
import { jwtDecode } from "jwt-decode";

function Courts() {
   const [courtData, setCourtData] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [isSaving, setIsSaving] = useState(false);
   const [selectedCourts, setSelectedCourts] = useState({});


   const accessToken = localStorage.getItem('accessToken');
   const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
   const cityId = selectedCity?.id;
   const userRole = accessToken ? jwtDecode(accessToken).role : null;

   useEffect(() => {
      fetchCourtData();
   }, []);

   const fetchCourtData = async () => {
      try {
         let query = `cityId=${cityId}`;
         console.log('fetch Court Data--', userRole)
         if (!null && userRole !== 1) {
            query += '&is_verified=1';
         }
         const response = await authApiService.get(`getCourtDetails?${query}`);
         if (response && response.data) {
            setCourtData(response.data);
            setIsLoading(false)
         }
      } catch (error) {
         console.error("Error fetching player profile data:", error);
      }
   };



   const states = [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
      "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
      "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
      "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
      "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
      "West Virginia", "Wisconsin", "Wyoming"
   ];

   const lightOptions = ["Yes", "No"];
   const numberOfCourts = Array.from({ length: 12 }, (_, i) => i + 1);
   const hours = Array.from({ length: 12 }, (_, i) => i + 1);
   const meridiem = ["AM", "PM"];


   // Handle input changes
   const handleInputChange = (index, field, value) => {
      setCourtData(prevData =>
         prevData.map((court, i) =>
            i === index ? { ...court, [field]: value } : court
         )
      );
   };


   const handleCheckboxChange = (id) => {
      setSelectedCourts((prev) => ({
         ...prev,
         [id]: !prev[id] // Toggle selection
      }));
   };

   /**
    * Updates court details
    */
   const updateCourtDetails = async () => {
      setIsSaving(true);
      setIsLoading(true);
      try {
         const response = await authApiService.put(
            `updateCourtDetails?id=${courtData[0].id}`,
            courtData
         );
         Modal.fire({
            icon: "success",
            title: "Updated!",
            text: "Court updated successfully!",
            timer: 2000,
            showConfirmButton: false,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#addd1e"
         });
         console.log("Update Response:", response);
         fetchCourtData();
      } catch (error) {
         console.error("Error updating court details:", error);
         Modal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.message || "Failed to update court.",
            confirmButtonText: "OK",
            confirmButtonColor: "#addd1e"
         });
      } finally {
         setIsSaving(false);
         setIsLoading(false); // Stop loading
      }
   };

   /**
    * Deletes a court with confirmation
    * @param {number} id - The court ID to delete
    */
   const deleteCourt = async (id) => {
      try {
         if (!selectedCourts[id]) {
            Modal.fire({
               icon: "warning",
               title: "Attention!",
               text: "Please check the checkbox before deleting.",
               timer: 2000,
               showConfirmButton: false,
               timerProgressBar: true,
               allowOutsideClick: false,
               allowEscapeKey: false,
               confirmButtonColor: "#addd1e"
            });
            return;
         }

         const result = await Modal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#addd1e",
            cancelButtonColor: "#b38ec1",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
         });

         if (result.isConfirmed) {
            try {
               const response = await authApiService.delete(`deleteCourt?id=${id}`);
               if (response && response.code === 200) {
                  Modal.fire({
                     icon: "success",
                     title: "Deleted!",
                     text: "Court deleted successfully!",
                     timer: 2000,
                     showConfirmButton: false,
                     timerProgressBar: true,
                     allowOutsideClick: false,
                     allowEscapeKey: false,
                     confirmButtonColor: "#addd1e"
                  });

                  setCourtData((prevData) => prevData.filter((court) => court.id !== id));
                  setSelectedCourts((prev) => {
                     const updatedSelection = { ...prev };
                     delete updatedSelection[id];
                     return updatedSelection;
                  });
               }
            } catch (error) {
               console.error("Error deleting court:", error);
               Modal.fire({
                  icon: "error",
                  title: "Error",
                  text: error.response?.data?.message || "Failed to delete court.",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#addd1e"
               });
            }
         }
      } catch (error) {
         console.error("Error in deleteCourt:", error);
      }
   };


   if (userRole !== 1) {
      return <CourtsDem courtData={courtData} isLoading={isLoading} />;
   }


   return (
      <div className="page-container col-sm-9">
         <div className="section"></div>
         {isLoading && !isSaving ? (
            <div className="loader-container" style={{
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               minHeight: '400px',
               width: '100%'
            }}>
               <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#4fa94d"
                  ariaLabel="three-dots-loading"
                  visible={true}
               />
            </div>
         ) : (
         <div className="court-section col-sm-12 mb-5">
            <div className="row">
            <div className="courts-page-heading">
            <h2>Local Courts </h2>
         </div>
               <form id="courts" method="post" >
                  <div className="row">
                 
                     {courtData.map((court, index) => (
                        <div key={court.id} className="threecol-frame col-sm-4 mb-4">
                           <div className="shadow-sm grey-box">
                              <p>
                                 <label htmlFor="name">Name</label>
                                 <input id="name" name={`courtList[${index}].name`} className="longBox" type="text" value={court.name} maxLength="30" onChange={(e) => handleInputChange(index, "name", e.target.value)} />
                              </p>
                              <p>
                                 <label htmlFor="courtAddress">Court Address:</label>
                                 <input id="courtAddress" name={`courtList[${index}].courtAddress`} className="longBox" type="text" value={court.court_address} maxLength="30" onChange={(e) => handleInputChange(index, "court_address", e.target.value)} />
                              </p>
                              <p>
                                 <label htmlFor="cities">City:</label>
                                 <input id="cities" name={`courtList[${index}].courtCity`} className="longBox" type="text" value={court.court_city} maxLength="30" onChange={(e) => handleInputChange(index, "court_city", e.target.value)}  readOnly/>
                              </p>
                              <p>
                                 <label htmlFor="courtState">State:</label>
                                 <select id="courtState" name={`courtList[${index}].courtState`} className="sixcol" value={court.court_state} onChange={(e) => handleInputChange(index, "court_state", e.target.value)}>
                                    {states.map((state, idx) => (
                                       <option key={idx} value={state}>{state}</option>
                                    ))}
                                 </select>
                              </p>
                              <p>
                                 <label>Lighted:</label>
                                 <select id="isCourtLighted" name={`courtList[${index}].isCourtLighted`} className="sixcol" value={court.court_lighted} onChange={(e) => handleInputChange(index, "court_lighted", e.target.value)}>
                                    <option value="">Select</option>
                                    {lightOptions.map((option, idx) => (
                                       <option key={idx} value={option}>{option}</option>
                                    ))}
                                 </select>
                              </p>
                              <p>
                                 <label>Number of Courts:</label>
                                 <select id="numberOfCourts" name={`courtList[${index}].numberOfCourts`} className="sixcol" value={court.numberOfCourts} onChange={(e) => handleInputChange(index, "numberOfCourts", e.target.value)}>
                                    <option value="">Select</option>
                                    {numberOfCourts.map(num => (
                                       <option key={num} value={num}>{num}</option>
                                    ))}
                                 </select>
                              </p>
                              <p>
                                 <label>Hours Open:</label>
                                 <select id="openCourtMeridiem" name={`courtList[${index}].openCourtMeridiem`} className="sixcol" value={court.openCourtMeridiem} onChange={(e) => handleInputChange(index, "openCourtMeridiem", e.target.value)}>
                                    <option value="">Select</option>
                                    {meridiem.map((m, idx) => (
                                       <option key={idx} value={m}>{m}</option>
                                    ))}
                                 </select>
                                 <select id="openCourtHour" name={`courtList[${index}].openCourtHour`} className="sixcol" value={court.openCourtHour} onChange={(e) => handleInputChange(index, "openCourtHour", e.target.value)}>
                                    <option value="">Select</option>
                                    {hours.map(hour => (
                                       <option key={hour} value={hour}>{hour}</option>
                                    ))}
                                 </select>
                              </p>
                              <p>
                                 <label>Hours Close:</label>
                                 <select id="closeCourtMeridiem" name={`courtList[${index}].closeCourtMeridiem`} className="sixcol" value={court.closeCourtMeridiem} onChange={(e) => handleInputChange(index, "closeCourtMeridiem", e.target.value)}>
                                    <option value="">Select</option>
                                    {meridiem.map((m, idx) => (
                                       <option key={idx} value={m}>{m}</option>
                                    ))}
                                 </select>
                                 <select id="closeCourtHour" name={`courtList[${index}].closeCourtHour`} className="sixcol" value={court.closeCourtHour} onChange={(e) => handleInputChange(index, "closeCourtHour", e.target.value)}>
                                    <option value="">Select</option>
                                    {hours.map(hour => (
                                       <option key={hour} value={hour}>{hour}</option>
                                    ))}
                                 </select>
                              </p>
                              <p>
                                 <label htmlFor={`courtVerified-${index}`}>Verified:</label>
                                 <input
                                    className='custom-checkbox'
                                    id={`courtVerified-${index}`}
                                    name={`courtList[${index}].courtVerified`}
                                    type="checkbox"
                                    checked={court.is_court_verified === true}
                                    onChange={(e) =>
                                       handleInputChange(index, "is_court_verified", e.target.checked)
                                    }
                                 />
                              </p>
                              <div>
                                 <div className="right submit-btn">
                                    {/* <input id={`id-${index}`} name={`courtList[${index}].id`} type="checkbox" value={court.id} className='mx-3' /> */}
                                    <input
                                       className='mx-3'
                                       type="checkbox"
                                       checked={selectedCourts[court.id] || false}
                                       onChange={() => handleCheckboxChange(court.id)}
                                    />
                                    <Link className="gray_dark_btn" to="#" onClick={() => deleteCourt(court.id)} >Delete</Link>

                                 </div>
                              </div>
                           </div>
                        </div>
                     ))}

                     {courtData.length > 0 && (
                        <div className="section px-3 col-md-12">
                           <div className="buttons">
                              <div className="left submit-btn">
                                 <div className="buttonwrapper">
                                    <Link to="#" onClick={updateCourtDetails} className="squarebutton"><span>Save</span></Link>
                                 </div>
                              </div>
                              {isLoading && <ThreeDots
                                 visible={true}
                                 height="80"
                                 width="80"
                                 color="#4fa94d"
                                 radius="9"
                                 ariaLabel="three-dots-loading"
                                 wrapperStyle={{ display: "flex", justifyContent: "center" }}
                                 wrapperClass=""
                              />
                              }
                              <div className="left cancel-btn">
                                 <div className="buttonwrapper">
                                    <a href="#" onClick={() => console.log("Cancel logic here")} className="squarebutton"><span>Cancel</span></a>
                                 </div>
                              </div>
                              <input id="bCancel" type="hidden" name="bCancel" value="false" />
                              <div className="clear"></div>
                           </div>
                        </div>
                     )}
                  </div>
               </form>

            </div>
         </div>
         )}
      </div>
   )
}

export default Courts
